import { TFunction } from 'i18next';
import { snakify } from 'helpers/syntaxHelper';

const EXPLORE_PATHNAME_REGEX = /^\/explore\/\d+$/;

export function validateRootChartUrl(url: string): boolean {
    try {
        const parsedURL = new URL(url);
        return EXPLORE_PATHNAME_REGEX.test(parsedURL.pathname);
    } catch {
        return false;
    }
}

/**
 * This helpers returns the list of the available functions to display in the
 * selectors from the chart template edition or creation modal.
 * The available functions consist of the keys from the allSoftwares object, translated and ordered.
 * @param {Record<string, string[]> | undefined} allSoftwares - The object containing the softwares list from the back.
 * @param {TFunction} t - Translation function
 */
export function getAvailableFunctions(
    allSoftwares: Record<string, string[]> | undefined,
    t: TFunction,
): { id: string; name: string }[] {
    if (!allSoftwares) return [];
    const availableFunctions = Object.keys(allSoftwares)
        .map((software) => ({
            id: software,
            name: t(`cellar.${snakify(software)}`),
        }))
        .sort((a, b) => new Intl.Collator().compare(a.name, b.name));
    return availableFunctions;
}
/**
 * This helpers returns the list of the available softwares to display in the
 * selectors from the chart template edition or creation modal.
 * The available softwares correspond to the list of softwares for each authorized function.
 * @param {Record<string, string[]> | undefined} allSoftwares - The object containing the softwares list from the back.
 * @param {AvailableMetricT[]} authorizedFunctions - The authorized functions for this chart template.
 */
export function getAvailableSoftwares(
    allSoftwares: Record<string, string[]> | undefined,
    authorizedFunctions: string[],
): string[] {
    if (!allSoftwares) return [];
    const availableSoftwares = authorizedFunctions
        .map((func) =>
            allSoftwares[func]
                .map((software) => software.toUpperCase())
                .sort((a, b) => new Intl.Collator().compare(a, b)),
        )
        .flat();
    return availableSoftwares;
}
